function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function removeSignFromUrl() {
    var url = window.location.href;
    if (url.indexOf("?#") > 0) {
        url = url.replace("?#", "#");
        window.location.href = url;
        return;
    }

    var qIndex = url.indexOf("?");
    var sharpIndex = url.indexOf("#");
    if (qIndex > -1 && qIndex < sharpIndex) {
        var first = url.substring(0, qIndex);
        var end = url.substring(sharpIndex, url.length);
        var newUrl = first.concat(end);
        window.location.href = newUrl;
        return;
    }

}


(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {

        $stateProvider
            .state('initSetupWizardV2', {
                parent: 'app',
                url: '/initSetupWizardV2?resetMode',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/wizards/init-setup-v2/init-setup-v2.html',
                        controller: 'InitSetupV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplierPanel');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', function ($stateParams) {
                        var resetMode = false;
                        if ($stateParams.resetMode != null && $stateParams.resetMode != undefined) {
                            resetMode = $stateParams.resetMode;
                        }

                        return {resetMode: resetMode};

                    }]
                }
            })
            .state('supplierPanel-v2', {
                parent: 'app',
                url: '/supplierPanel-v2',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/supplier-v2/supplierPanel-v2.html',

                        controller: 'SupplierPanelV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplierPanel');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.more', {
                parent: 'supplierPanel-v2',
                url: '/more',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/layouts/more/more.html',
                        controller: 'MoreController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.dashboard', {
                parent: 'supplierPanel-v2',
                url: '/dashboard',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'supplierPanel.sideMenu.dashboard'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/dashboard/main/report.main_dashboard_v2.html',
                        controller: 'MainDashboardV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', '$rootScope', function ($translate, $translatePartialLoader, $rootScope) {

                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('newsType');
                        $rootScope.$broadcast('showNavBar');
                        removeSignFromUrl();
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.calendar', {
                parent: 'supplierPanel-v2',
                url: '/calendar',
                data: {
                    authorities: ['ROLE_RESERVATION_MANAGER'],
                    pageTitle: 'global.setup.timeBoard'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/time-board/book-calendar-v2.template.html',
                        controller: 'BookCalendarV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('servant');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.calendar-v2', {
                parent: 'supplierPanel-v2',
                url: '/calendar-v2',
                data: {
                    authorities: ['ROLE_RESERVATION_MANAGER'],
                    pageTitle: 'global.setup.timeBoard'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/time-board/calendar-vue.template.html',
                        controller: 'BookCalendarV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('servant');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.caledarConfig', {
                parent: 'supplierPanel-v2',
                url: '/calendarConfig',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'global.setup.timeBoard'
                },
                onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', 'Principal', function ($stateParams, $state, $uibModal, $rootScope, Principal) {
                    $rootScope.modalInstance = $uibModal.open({
                        templateUrl: 'app/time-board/filter-dialog.template-v2.html',
                        controller: 'BookCalendarV2Controller',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        windowClass: 'pl-modal',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('personInfo');
                                $translatePartialLoader.addPart('locationInfo');
                                return $translate.refresh();
                            }]
                        }
                    });


                    $rootScope.modalInstance.result.then(function () {
                        if ($rootScope.fromState.name)
                            $state.go($rootScope.fromState.name);
                        else
                            $state.go('supplierPanel-v2.dashboard');

                    }, function () {
                        if ($rootScope.fromState.name)
                            $state.go($rootScope.fromState.name);
                        else
                            $state.go('supplierPanel-v2.dashboard');
                    });
                }]

            })
            .state('supplierPanel-v2.calendar.servantExceptionTimes', {
                parent: 'supplierPanel-v2.calendar',
                url: '/servantExceptionTimes/{availabilityMode}/{defaultServantId}',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/servant-exception-duration/servant-exception-duration.html',
                        controller: 'ServantExceptionDurationController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('scheduleInfo');

                        return $translate.refresh();
                    }],
                    entity: ['Principal', '$stateParams', function (Principal, $stateParams) {
                        // removeSignFromUrl();
                        // return CompanySubscriptionStatusCustom.findActiveCompanySubscription().query();
                        var multiServant = true;
                        Principal.hasAuthority("ROLE_SERVANT_LOGIN").then(function (has) {
                            multiServant = !has;
                        });

                        var availabilityMode = $stateParams.availabilityMode;
                        var defaultServantId = $stateParams.defaultServantId;
                        return {
                            defaultServantId: defaultServantId,
                            availabilityMode: availabilityMode,
                            canSelectServant: multiServant

                        };
                    }]
                }
            })
            .state('supplierPanel-v2.new-reserve-modal', {
                parent: 'supplierPanel-v2.calendar-v2',
                url: '/reserve-modal/new/{serviceItemId}/{start_date}/{end_date}/{servantId}/{hasCustomTime}',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/reserve/new-reserve-modal-v2.html',
                        controller: 'ReserveV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('genderType');

                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            customer: null,
                            createDate: null,
                            status: 0,
                            id: null,
                            orderBagServiceItems: [{}]
                        };
                    }

                }
            })
            //reserve
            .state('supplierPanel-v2.reserveList', {
                parent: 'supplierPanel-v2',
                url: '/reserveList?pageSize&sort&searchText&filterQuery',
                reloadOnSearch: false, 
                data: {
                    authorities: ['ROLE_RESERVATION_MANAGER'],
                    pageTitle: 'supplierPanel.sideMenu.orderBagList'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/reserve/reserve-list-v2.html',
                        controller: 'ReserveListController',
                        controllerAs: 'vm'
                    }
                },
               params: {
                    pageSize: { value: '10', squash: true },
                    sort: { value: 'id,asc', squash: true },
                    searchText: { value: null },
                    filterQuery: { value: null }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            // page: PaginationUtil.parsePage($stateParams.page),
                            page: parseInt($stateParams.page || 1, 10),
                             pageSize: parseInt($stateParams.pageSize || 10, 10),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.searchText
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('servant');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    formMode: function () {
                        return {
                            mode: 'LoadOnHand'
                        };
                    }

                }
            })
            .state('supplierPanel-v2.reserveWithCustomerParameter', {
                parent: 'supplierPanel-v2',
                url: '/reserveWithCustomerParameter/{customerId}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.orderBag.detail.title'
                },
                onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', function ($stateParams, $state, $uibModal, $rootScope) {
                    $rootScope.modalInstance = $uibModal.open({
                        templateUrl: 'app/entities/reserve/new-reserve-modal.html',
                        controller: 'ReserveController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        windowClass: 'pl-modal',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('serviceItem');
                                $translatePartialLoader.addPart('orderBag');
                                $translatePartialLoader.addPart('orderBagServiceItem');
                                $translatePartialLoader.addPart('personInfo');
                                $translatePartialLoader.addPart('global');
                                $translatePartialLoader.addPart('genderType');

                                return $translate.refresh();
                            }],
                            entity: function () {
                                return {
                                    customer: null,
                                    createDate: null,
                                    status: 0,
                                    id: null,
                                    orderBagServiceItems: [{}]
                                };
                            }

                        }
                    });

                    $rootScope.modalInstance.result.then(function () {

                        $state.go('supplierPanel-v2.companyCustomer', null, {reload: true});
                        $rootScope.modalInstance.dismiss('cancel');
                    }, function () {
                        var prevState = $rootScope.fromState.name;
                        if ($rootScope.fromStateParams)
                            $state.go(prevState, {id: $rootScope.fromStateParams.id});
                        else
                            $state.go(prevState);
                    });
                }]
            })
            .state('supplierPanel-v2.editOrderBag', {
                parent: 'supplierPanel-v2',
                url: '/{id}/editOrderBag',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/order-bag/edit-order-bag-v2.html',
                        controller: 'EditOrderBagV2Controller',
                        controllerAs: 'vm'
                    }
                },

                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('orderBagServiceItemDtail');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('paymentType');
                        $translatePartialLoader.addPart('invoiceStatus');
                        $translatePartialLoader.addPart('invoiceInfo');


                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'OrderBagCustom', function ($stateParams, OrderBagCustom) {
                        return OrderBagCustom.getOrderBagWithEntities($stateParams.id).query();
                    }
                    ],
                    invoiceInfoEntity: ['$stateParams', 'InvoiceInfoCustom', function ($stateParams, InvoiceInfoCustom) {
                        return InvoiceInfoCustom.getInvoiceByOrderBagId($stateParams.id).query();
                    }]

                }
            })
            .state('supplierPanel-v2.editOrderBag.editCompanyCustomer', {
                parent: 'supplierPanel-v2.editOrderBag',
                url: '/editCompanyCustomer/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/company-customer/company-customer-modal.html',
                        controller: 'CompanyCustomerModalController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('personInfo');
                        return $translate.refresh();
                    }],
                    entity: ['CompanyCustomer', '$stateParams', function (CompanyCustomer, $stateParams) {
                        return CompanyCustomer.get({id: $stateParams.id}).$promise;
                    }]
                }
                // });
            })
            .state('supplierPanel-v2.newReserve', {
                parent: 'supplierPanel-v2.reserveList',
                url: '/reserve-modal/new/{serviceItemId}/{start_date}/{end_date}/{servantId}/{hasCustomTime}',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/reserve/new-reserve-modal-v2.html',
                        controller: 'ReserveV2Controller',
                        controllerAs: 'vm',
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('genderType');

                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            customer: null,
                            createDate: null,
                            status: 0,
                            id: null,
                            orderBagServiceItems: [{}]
                        };
                    }

                }
            })
            //.........................
            //subscription
            .state('supplierPanel-v2.companySubscriptionStatusV2', {
                parent: 'supplierPanel-v2',
                url: '/companySubscriptionStatusV2',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'global.menu.account.subscription'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-subscription-status/company-buy-subscription.html',
                        controller: 'CompanyBuySubscriptionController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('companySubscriptionStatus');
                        $translatePartialLoader.addPart('subscriptionType');
                        $translatePartialLoader.addPart('subscriptionPackage');
                        $translatePartialLoader.addPart('packageFeatureList');
                        return $translate.refresh();
                    }]
                    ,
                    entity: ['CompanyCustom', 'ActivityTypeInfoCustom', function (CompanyCustom, ActivityTypeInfoCustom) {
                        return ActivityTypeInfoCustom.getActivityTypeInfoByCurrentCompany().query().$promise;
                    }]
                }
            })
            .state('supplierPanel-v2.companySmsPackageStatus', {
                parent: 'supplierPanel-v2',
                url: '/companySmsPackageStatus',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'global.menu.account.sms_package_status'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-subscription-status/company-sms-package-status-view-v2.html',
                        controller: 'CompanySmsPackageStatusViewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('companySubscriptionStatus');
                        $translatePartialLoader.addPart('subscriptionType');
                        $translatePartialLoader.addPart('subscriptionPackage');
                        return $translate.refresh();
                    }]
                    ,
                    entity: ['CompanySubscriptionStatusCustom', function (CompanySubscriptionStatusCustom) {
                        removeSignFromUrl();
                        // return CompanySubscriptionStatusCustom.findActiveCompanySubscription().query();
                    }]
                }
            })
            .state('supplierPanel-v2.companySubscriptionHistory', {
                parent: 'supplierPanel-v2',
                url: '/companySubscriptionHistory' + ':packageType',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'global.menu.account.subscription_history'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-subscription-status/company-subscription-histories.html',
                        controller: 'CompanySubscriptionHistoriesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('companySubscriptionStatus');
                        $translatePartialLoader.addPart('subscriptionType');
                        $translatePartialLoader.addPart('subscriptionPackage');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('paymentType');
                        $translatePartialLoader.addPart('packageType');
                        $translatePartialLoader.addPart('global');


                        return $translate.refresh();
                    }]
                }
            })

            .state('supplierPanel-v2.purchaseSubscription', {
                parent: 'supplierPanel-v2',
                url: '/{id}/purchaseSubscription',
                data: {
                    authorities: ['ROLE_USER'],
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-subscription-status/purchase-subscription-v2.html',
                        controller: 'PurchaseSubscriptionController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('companySubscriptionStatus');
                        $translatePartialLoader.addPart('subscriptionType');
                        $translatePartialLoader.addPart('subscriptionPackage');
                        $translatePartialLoader.addPart('coupon');
                        $translatePartialLoader.addPart('supplierCoupon');
                        return $translate.refresh();
                    }]
                    ,
                    entity: ['$stateParams', 'SubscriptionPackage', function ($stateParams, SubscriptionPackage) {

                        if ($stateParams.id != '')

                            return SubscriptionPackage.get({id: $stateParams.id}).$promise;
                        return {};
                    }]
                }
            })
            //................
            .state('supplierPanel-v2.companyCustomer', {
                parent: 'supplierPanel-v2',
                url: '/company-customer-list?page&sort&searchText',
                data: {
                    authorities: ['ROLE_CUSTOMER_MANAGER'],
                    pageTitle: 'tikonApp.companyCustomer.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-customer/company-customers-list-v2.html',
                        controller: 'CompanyCustomerListV2Controller',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    searchText: { value: null },
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('customerStatus');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('scheduleType');

                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.companyCustomer.new', {
                parent: 'supplierPanel-v2',
                url: '/company-customer-list/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/company-customer/company-customer-modal.html',
                        controller: 'CompanyCustomerModalController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('personInfo');
                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            id: null
                        };
                    }
                }
            })
            .state('supplierPanel-v2.companyCustomer.edit', {
                parent: 'supplierPanel-v2',
                url: '/company-customer-list/edit/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/company-customer/company-customer-modal.html',
                        controller: 'CompanyCustomerModalController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('wallet');
                        return $translate.refresh();
                    }],
                    entity: ['CompanyCustomer', '$stateParams', function (CompanyCustomer, $stateParams) {
                        return CompanyCustomer.get({id: $stateParams.id}).$promise;
                    }]
                }
                // });
            })
            .state('supplierPanel-v2.companyCustomer.delete', {
                parent: 'supplierPanel-v2.companyCustomer',
                url: '/company-customer-list/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', function ($stateParams, $state, $uibModal, $rootScope) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-customer/company-customer-delete-dialog.html',
                        controller: 'CompanyCustomerDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['CompanyCustomer', function (CompanyCustomer) {
                                return CompanyCustomer.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        if ($rootScope.modalInstance) {
                            $rootScope.modalInstance.dismiss('cancel');
                        }
                        $state.go('supplierPanel-v2.companyCustomer', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.deleteCompanyCustomer', {
                parent: 'supplierPanel-v2.companyCustomer.edit',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', function ($stateParams, $state, $uibModal, $rootScope) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-customer/company-customer-delete-dialog.html',
                        controller: 'CompanyCustomerDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['CompanyCustomer', function (CompanyCustomer) {
                                return CompanyCustomer.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        if ($rootScope.modalInstance) {
                            $rootScope.modalInstance.dismiss('cancel');
                        }
                        $state.go('supplierPanel-v2.companyCustomer', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.companyCustomer.invoiceInfoDetail', {
                parent: 'supplierPanel-v2',
                url: '/company-customer/invoice-detail/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/invoice-info/invoice-info-actions-v2.html',
                        controller: 'InvoiceInfoActionsV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('invoiceInfo');
                        $translatePartialLoader.addPart('invoiceInfoItem');
                        $translatePartialLoader.addPart('invoiceStatus');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('paymentType');
                        $translatePartialLoader.addPart('serviceAddOn');
                        return $translate.refresh();
                    }],
                    entity: ['InvoiceInfoCustom', '$stateParams', function (InvoiceInfoCustom, $stateParams) {

                        return InvoiceInfoCustom.getInvoiceWithItemsById($stateParams.id).query().$promise;
                    }]
                }
                // resolve: {
                //     entity: ['CompanyCustomer', function(CompanyCustomer) {
                //         return CompanyCustomer.get({id : $stateParams.id}).$promise;
                //     }]
                // }
            })
            .state('supplierPanel-v2.companyCustomer.editInvoiceInfo', {
                parent: 'supplierPanel-v2',
                url: '/company-customer/editInvoiceInfo/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/invoice-info/invoice-info-dialog-v2.html',
                        controller: 'InvoiceInfoDialogV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('invoiceInfo');
                        $translatePartialLoader.addPart('invoiceStatus');
                        $translatePartialLoader.addPart('invoiceInfoItem');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('serviceAddOn');
                        return $translate.refresh();
                    }],
                    entity: ['InvoiceInfoCustom', '$stateParams', function (InvoiceInfoCustom, $stateParams) {

                        return InvoiceInfoCustom.getInvoiceWithItemsById($stateParams.id).query().$promise;
                    }]
                }
                // resolve: {
                //     entity: ['CompanyCustomer', function(CompanyCustomer) {
                //         return CompanyCustomer.get({id : $stateParams.id}).$promise;
                //     }]
                // }
            })
            //......................................................

            .state('supplierPanel-v2.companyServants', {
                parent: 'supplierPanel-v2',
                url: '/company-servants?searchText',
                data: {
                    authorities: ['ROLE_SERVANT_MANAGER'],
                    pageTitle: 'supplierPanel.sideMenu.servantInfo'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-servants/company-servants-v2.html',
                        controller: 'CompanyServantsV2Controller',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                     searchText: { value: null },
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('servant');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.companyServants.new', {
                parent: 'supplierPanel-v2',
                url: '/companyServants/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/company-servants/company-servants-v2-dialog.html',
                        controller: 'CompanyServantsV2DialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('servant');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            title: null,
                            level: null,
                            id: null
                        };
                    }
                }
                // });
            })
            .state('supplierPanel-v2.companyServants.edit', {
                parent: 'supplierPanel-v2',
                url: '/companyServants/edit/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/company-servants/company-servants-v2-dialog.html',
                        controller: 'CompanyServantsV2DialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('servant');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['Servant', '$stateParams', function (Servant, $stateParams) {
                        return Servant.get({id: $stateParams.id}).$promise;
                    }]
                }
                // });
            })
            .state('supplierPanel-v2.companyServants.delete', {
                parent: 'supplierPanel-v2.companyServants',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-servants/company-servants-delete-dialog.html',
                        controller: 'CompanyServantsDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Servant', function (Servant) {
                                return Servant.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.companyServants', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.companyServants.edit.delete', {
                parent: 'supplierPanel-v2.companyServants.edit',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/company-servants/company-servants-delete-dialog.html',
                        controller: 'CompanyServantsDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Servant', function (Servant) {
                                return Servant.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.companyServants', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.companyServants.servantExceptionTimes', {
                parent: 'supplierPanel-v2.companyServants.edit',
                url: '/servantExceptionTimes/{availabilityMode}/{defaultServantId}',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/servant-exception-duration/servant-exception-duration.html',
                        controller: 'ServantExceptionDurationController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('scheduleInfo');

                        return $translate.refresh();
                    }],
                    entity: ['Principal', '$stateParams', function (Principal, $stateParams) {
                        // removeSignFromUrl();
                        // return CompanySubscriptionStatusCustom.findActiveCompanySubscription().query();
                        var multiServant = true;
                        Principal.hasAuthority("ROLE_SERVANT_LOGIN").then(function (has) {
                            multiServant = !has;
                        });

                        var availabilityMode = $stateParams.availabilityMode;
                        var defaultServantId = $stateParams.defaultServantId;
                        return {
                            defaultServantId: defaultServantId,
                            availabilityMode: availabilityMode,
                            canSelectServant: multiServant

                        };
                    }]
                }
            })
            .state('supplierPanel-v2.serviceItemList', {
                parent: 'supplierPanel-v2',
                url: '/serviceItemList' + '-' + ':type?searchText',
                data: {
                    authorities: ['ROLE_CATEGORY_MANAGER'],
                    pageTitle: 'supplierPanel.sideMenu.servicelist'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/service-item-v2/service-item-list-v2.html',
                        controller: 'ServiceItemListV2Controller',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    searchText: { value: null }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('serviceItemType');
                        $translatePartialLoader.addPart('serviceItemStatus');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }],

                }
            })
            .state('supplierPanel-v2.serviceItemList.serviceItem', {
                parent: 'supplierPanel-v2.serviceItemList',
                url: '/serviceItemList/serviceItem/{id}',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/service-item-v2/service-item-v2.html',
                        controller: 'ServiceItemV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('serviceCapacityInfo');
                        $translatePartialLoader.addPart('messages');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItemStatus');
                        $translatePartialLoader.addPart('servicePaymentType');
                        $translatePartialLoader.addPart('serviceConfirmationType');
                        $translatePartialLoader.addPart('amenitiesType');
                        $translatePartialLoader.addPart('weekDay');
                        return $translate.refresh();
                    }],
                    entity: ['$rootScope', '$stateParams', 'ServiceItem', function ($rootScope, $stateParams, ServiceItem) {
                        if ($stateParams.id != '')
                            return ServiceItem.get({id: $stateParams.id}).$promise;
                        return {};
                    }]
                }
            })
            .state('supplierPanel-v2.serviceItemList.delete', {
                parent: 'supplierPanel-v2.serviceItemList',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']


                },
                onEnter: ['$state', '$stateParams', '$uibModal', function ($state, $stateParams, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-item-v2/service-item-delete-dialog-v2.html',
                        controller: 'ServiceItemDeleteV2Controller',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ServiceItem', function (ServiceItem) {
                                return ServiceItem.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.serviceItemList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.serviceItemList.copy', {
                parent: 'supplierPanel-v2.serviceItemList',
                url: '/{id}/copy',
                data: {
                    authorities: ['ROLE_USER'],

                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-item-v2/service-item-copy-dialog-v2.html',
                        controller: 'ServiceItemCopyV2Controller',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ServiceItem', function (ServiceItem) {
                                return ServiceItem.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.serviceItemList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.serviceItemList.serviceItem.delete', {
                parent: 'supplierPanel-v2.serviceItemList.serviceItem',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']


                },
                onEnter: ['$state', '$uibModal', function ($state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-item-v2/service-item-delete-dialog-v2.html',
                        controller: 'ServiceItemDeleteV2Controller',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['$stateParams', 'ServiceItem', function ($stateParams, ServiceItem) {
                                return ServiceItem.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.serviceItemList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.serviceItemList.serviceItem.copy', {
                parent: 'supplierPanel-v2.serviceItemList.serviceItem',
                url: '/{id}/copy',
                data: {
                    authorities: ['ROLE_USER'],

                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-item-v2/service-item-copy-dialog-v2.html',
                        controller: 'ServiceItemCopyV2Controller',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ServiceItem', function (ServiceItem) {
                                return ServiceItem.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.serviceItemList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })

            .state('supplierPanel-v2.eventItemList', {
                parent: 'supplierPanel-v2',
                url: '/eventItemList?searchText',
                data: {
                    authorities: ['ROLE_CATEGORY_MANAGER'],
                    pageTitle: 'supplierPanel.sideMenu.eventItemList'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/service-item-v2/event-item-list-v2.html',
                        controller: 'EventItemListV2Controller',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    searchText: { value: null }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('eventItem');
                        $translatePartialLoader.addPart('serviceItemType');
                        $translatePartialLoader.addPart('serviceItemStatus');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }],

                }
            })
            .state('supplierPanel-v2.eventItemList.eventItem', {
                parent: 'supplierPanel-v2.eventItemList',
                url: '/eventItem/{id}',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/service-item-v2/service-item-v2.html',
                        controller: 'ServiceItemV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('serviceCapacityInfo');
                        $translatePartialLoader.addPart('messages');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItemStatus');
                        $translatePartialLoader.addPart('servicePaymentType');
                        $translatePartialLoader.addPart('serviceConfirmationType');
                        $translatePartialLoader.addPart('amenitiesType');
                        $translatePartialLoader.addPart('weekDay');
                        return $translate.refresh();
                    }],
                    entity: ['$rootScope', '$stateParams', 'ServiceItem', function ($rootScope, $stateParams, ServiceItem) {
                        if ($stateParams.id != '')
                            return ServiceItem.get({id: $stateParams.id}).$promise;
                        return {
                            serviceMode: 'EVENT',
                            id: null
                        }
                    }]
                }
            })
            .state('supplierPanel-v2.eventItemList.delete', {
                parent: 'supplierPanel-v2.eventItemList',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-item-v2/service-item-delete-dialog-v2.html',
                        controller: 'ServiceItemDeleteV2Controller',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ServiceItem', function (ServiceItem) {
                                return ServiceItem.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.eventItemList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.eventItemList.copy', {
                parent: 'supplierPanel-v2.eventItemList',
                url: '/{id}/copy',
                data: {
                    authorities: ['ROLE_USER'],

                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-item-v2/service-item-copy-dialog-v2.html',
                        controller: 'ServiceItemCopyV2Controller',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ServiceItem', function (ServiceItem) {
                                return ServiceItem.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.eventItemList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.eventItemList.eventItem.delete', {
                parent: 'supplierPanel-v2.eventItemList.eventItem',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$state', '$uibModal', function ($state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-item-v2/service-item-delete-dialog-v2.html',
                        controller: 'ServiceItemDeleteV2Controller',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['$stateParams', 'ServiceItem', function ($stateParams, ServiceItem) {
                                return ServiceItem.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.eventItemList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.eventItemList.eventItem.copy', {
                parent: 'supplierPanel-v2.eventItemList.eventItem',
                url: '/{id}/copy',
                data: {
                    authorities: ['ROLE_USER'],

                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-item-v2/service-item-copy-dialog-v2.html',
                        controller: 'ServiceItemCopyV2Controller',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ServiceItem', function (ServiceItem) {
                                return ServiceItem.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.eventItemList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })


            .state('supplierPanel-v2.companyServiceCategoryList', {
                parent: 'supplierPanel-v2',
                url: '/company-service-category-list',
                data: {
                    authorities: []
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/service-category/company-service-category-list-v2.html',
                        controller: 'CompanyServiceCategoryListV2Controller',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    entity: function () {
                        return {
                            mode: 'RESERVE'
                        };
                    },
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceCategory');
                        $translatePartialLoader.addPart('eventItem');
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.companyServiceCategoryList.new', {
                parent: 'supplierPanel-v2.companyServiceCategoryList',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/service-category/company-service-category-dialog-v2.html',
                        controller: 'CompanyServiceCategoryDialogV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            categoryName: null,
                            id: null
                        };
                    }
                }
            })
            .state('supplierPanel-v2.companyServiceCategoryList.edit', {
                parent: 'supplierPanel-v2.companyServiceCategoryList',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/service-category/company-service-category-dialog-v2.html',
                        controller: 'CompanyServiceCategoryDialogV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ServiceCategory', function ($stateParams, ServiceCategory) {
                        return ServiceCategory.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('supplierPanel-v2.companyServiceCategoryList.delete', {
                parent: 'supplierPanel-v2.companyServiceCategoryList',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-category/service-category-delete-dialog.html',
                        controller: 'ServiceCategoryDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ServiceCategory', function (ServiceCategory) {
                                return ServiceCategory.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.companyServiceCategoryList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.deleteCompanyServiceCategory', {
                parent: 'supplierPanel-v2.companyServiceCategoryList.edit',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/service-category/service-category-delete-dialog.html',
                        controller: 'ServiceCategoryDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ServiceCategory', function (ServiceCategory) {
                                return ServiceCategory.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.companyServiceCategoryList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })


            .state('supplierPanel-v2.partialFormPersonInfo', {
                parent: 'supplierPanel-v2',
                url: '/userProfile',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'global.menu.account.userProfile'
                },
                onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', 'Principal', function ($stateParams, $state, $uibModal, $rootScope, Principal) {
                    $rootScope.modalInstance = $uibModal.open({
                        templateUrl: 'app/userprofile/user-profiles-v2.html',
                        controller: 'UserProfileV2Controller',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        windowClass: 'pl-modal',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('personInfo');
                                $translatePartialLoader.addPart('locationInfo');
                                return $translate.refresh();
                            }]
                            ,
                            entity: ['UserProfileQuery', function (UserProfileQuery) {
                                return UserProfileQuery.getCurrentPersonInfo().query();
                            }]
                        }
                    });


                    $rootScope.modalInstance.result.then(function () {
                        if ($rootScope.fromState.name)
                            $state.go($rootScope.fromState.name);
                        else
                            $state.go('supplierPanel-v2.dashboard');

                    }, function () {
                        if ($rootScope.fromState.name)
                            $state.go($rootScope.fromState.name);
                        else
                            $state.go('supplierPanel-v2.dashboard');
                    });
                }]

            })
            .state('supplierPanel-v2.password', {
                parent: 'supplierPanel-v2',
                url: '/password',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'global.menu.account.password'
                },
                onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', 'Principal', function ($stateParams, $state, $uibModal, $rootScope, Principal) {
                    $rootScope.modalInstance = $uibModal.open({
                        templateUrl: 'app/account/password/password-v2.html',
                        controller: 'PasswordV2Controller',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        windowClass: 'pl-modal',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('password');
                                return $translate.refresh();
                            }]
                            // ,
                            // entity: ['UserProfileQuery', function (UserProfileQuery) {
                            //     return UserProfileQuery.getCurrentPersonInfo().query();
                            // }]
                        }
                    });


                    $rootScope.modalInstance.result.then(function () {
                        $state.go('supplierPanel-v2.more');

                    }, function () {
                        $state.go('supplierPanel-v2.more');
                    });
                }]

            })
            //report
            .state('supplierPanel-v2.reportExport', {
                parent: 'supplierPanel-v2',
                url: '/reportExport',
                data: {
                    authorities: ['ROLE_REPORT_MANAGER'],
                    pageTitle: 'supplierPanel.sideMenu.reports'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/reports/report-export-v2.html',
                        controller: 'ReportExportController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('invoiceInfo');
                        $translatePartialLoader.addPart('invoiceStatus');
                        $translatePartialLoader.addPart('reportExport');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.reportExport.orderbag_list_by_service', {
                parent: 'supplierPanel-v2.reportExport',
                url: '/orderbag_list_by_service',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/reports/orderbag_list_by_service/orderbag_list_by_service.html',
                        controller: 'OrderbagListByServiceController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg'
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.reportExport.orderbag_list_by_service', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.reportExport.financial_by_customer', {
                parent: 'supplierPanel-v2.reportExport',
                url: '/financial_by_customer',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/reports/financial_by_customer/financial_by_customer.html',
                        controller: 'FinancialByCustomerController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg'
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.reportExport.financial_by_customer', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.reportExport.reserve_list_dtail_report', {
                parent: 'supplierPanel-v2.reportExport',
                url: '/reserve_list_dtail_report',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/reports/reserve_list_dtail_report/reserve_list_dtail_report.html',
                        controller: 'ReserveListDtailReportController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg'
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.reportExport.reserve_list_dtail_report', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.reportExport.reserve_list_summary_report', {
                parent: 'supplierPanel-v2.reportExport',
                url: '/reserve_list_summary_report',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/reports/reserve_list_dtail_report/reserve_list_dtail_report.html',
                        controller: 'ReserveListSummaryReportController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg'
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.reportExport.reserve_list_dtail_report', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.reportExport.reserve_list_summary_with_payment_report', {
                parent: 'supplierPanel-v2.reportExport',
                url: '/reserve_list_summary_with_payment_report',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/reports/reserve_list_summary_with_payment_report/reserve_list_summary_with_payment_report.html',
                        controller: 'ReserveListSummaryWithPaymentReportController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg'
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.reportExport.reserve_list_summary_with_payment_report', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.reportExport.invoice_info_item_report', {
                parent: 'supplierPanel-v2.reportExport',
                url: '/invoice_info_item_report',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/reports/invoice_info_item_report/invoice_info_item_report.html',
                        controller: 'InvoiceInfoItemReportController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg'
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.reportExport.invoice_info_item_report', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.reportExport.sum_of_reserve_count', {
                parent: 'supplierPanel-v2.reportExport',
                url: '/sum_of_reserve_count',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/reports/sum_of_reserve_count/sum_of_reserve_count.html',
                        controller: 'SumOfReserveCountController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg'
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.reportExport.sum_of_reserve_count', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.reportExport.company_customer_form_data_report', {
                parent: 'supplierPanel-v2',
                url: '/company_customer_form_data_report',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.invoiceInfo.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/reports/company-customer-form-data-report/company-customer-form-data-report.html',
                        controller: 'CompanyCustomerFormDataReportController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('companyCustomer');
                        // $translatePartialLoader.addPart('companyCustomerFormData');
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');


                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.reportExport.company_customer_form_data_report.print', {
                parent: 'supplierPanel-v2.reportExport.company_customer_form_data_report',
                url: '/company-customer-form-data/print/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reports/company-customer-form-data-report/print-company-customer-form-data.html',
                        controller: 'PrintCompanyCustomerFormDataController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['CompanyCustomerFormDataReportCustom', '$stateParams', function (CompanyCustomerFormDataReportCustom, $stateParams) {

                        return CompanyCustomerFormDataReportCustom.getCompanyCustomerFormDataById($stateParams.id).query().$promise;
                    }]
                }
                // resolve: {
                //     entity: ['CompanyCustomer', function(CompanyCustomer) {
                //         return CompanyCustomer.get({id : $stateParams.id}).$promise;
                //     }]
                // }
            })
            .state('supplierPanel-v2.reportExport.company_form_data_list', {
                parent: 'supplierPanel-v2.reportExport',
                url: '/company_form_data_list',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/reports/company_form_data_list/company_form_data_list.html',
                        controller: 'CompanyFormDataListController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg'
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.reportExport.company_form_data_list', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            //.............
            //companyPaymentLog
            .state('supplierPanel-v2.companyPaymentLogList', {
                parent: 'supplierPanel-v2',
                url: '/companyPaymentLog?size&filterQuery&query',
                data: {
                    // authorities: ['ROLE_FINANCIAL_MANAGER'],
                    pageTitle: 'tikonApp.companyPaymentLog.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-payment-log/company-payment-log-list-v2.html',
                        controller: 'CompanyPaymentLogListV2Controller',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    size: { value: '10', squash: true },
                    sort: { value: 'id,asc', squash: true },
                    query: { value: null },
                    filterQuery: { value: null }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyPaymentLog');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('bankAccountInfo');
                        $translatePartialLoader.addPart('accountClearingRequestStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.companyAllPaymentLogList', {
                parent: 'supplierPanel-v2',
                url: '/companyAllPaymentLog',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.companyPaymentLog.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-payment-log/company-all-payment-log-list-v2.html',
                        controller: 'CompanyAllPaymentLogListController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyPaymentLog');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('bankAccountInfo');
                        $translatePartialLoader.addPart('accountClearingRequestStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
             .state('supplierPanel-v2.companyApprovalPaymentLogList', {
                parent: 'supplierPanel-v2',
                url: '/companyApprovalPaymentLog?size&filterQuery&query',
                data: {
                    authorities: ['ROLE_FINANCIAL_MANAGER'],
                    pageTitle: 'tikonApp.companyPaymentLog.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-payment-log/company-approval-payment-log-list.html',
                        controller: 'CompanyApprovalPaymentLogList',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    size: { value: '10', squash: true },
                    sort: { value: 'id,asc', squash: true },
                    query: { value: null },
                    filterQuery: { value: null }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyPaymentLog');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('bankAccountInfo');
                        $translatePartialLoader.addPart('paymentType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.companyApprovalPaymentLogListV2', {
                parent: 'supplierPanel-v2',
                url: '/companyApprovalPaymentLog-v2?size&filterQuery&query',
                data: {
                    authorities: ['ROLE_FINANCIAL_MANAGER'],
                    pageTitle: 'tikonApp.companyPaymentLog.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-payment-log/company-approval-payment-log-list-v2.html',
                        controller: 'CompanyApprovalPaymentLogListV2'
                    }
                },
                params: {
                    size: { value: '10', squash: true },
                    sort: { value: 'id,asc', squash: true },
                    query: { value: null },
                    filterQuery: { value: null }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyPaymentLog');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('bankAccountInfo');
                        $translatePartialLoader.addPart('paymentType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.accountClearingList', {
                parent: 'supplierPanel-v2',
                url: '/accountClearingList',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.accountClearingRequest.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/account-clearing-request/account-clearing-requests-v2.html',
                        controller: 'AccountClearingRequestsV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('accountClearingRequest');
                        $translatePartialLoader.addPart('accountClearingRequestStatus');
                        $translatePartialLoader.addPart('companyPaymentLog');
                        $translatePartialLoader.addPart('global');

                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.accountClearingDetail', {
                parent: 'supplierPanel-v2',
                url: '/accountClearingDetail/detail/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.accountClearingRequest.detail.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/account-clearing-request/account-clearing-request-detail-v2.html',
                        controller: 'AccountClearingRequestDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('bankAccountInfo');
                        $translatePartialLoader.addPart('accountClearingRequest');
                        $translatePartialLoader.addPart('accountClearingRequestStatus');
                        $translatePartialLoader.addPart('companyPaymentLog');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('global');

                        return $translate.refresh();
                    }]
                }
            })

            .state('supplierPanel-v2.setting', {
                parent: 'supplierPanel-v2',
                url: '/setting',
                data: {
                    authorities: ['ROLE_COMPANY_MANAGER'],
                    pageTitle: 'supplierPanel.sideMenu.setting'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/dashboard/setting/setting-v2.html',
                        controller: 'SettingController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('settingInfo');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.companyInfo', {
                parent: 'supplierPanel-v2',
                url: '/companyInfo',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/company/company-info-v2.html',
                        controller: 'CompanyInfoV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('activityType');
                        return $translate.refresh();
                    }]
                    //entity: ['$stateParams', 'Company', function ($stateParams, Company) {
                    //    return Company.get({id: $stateParams.id}).$promise;
                    //}]
                }
            })
            .state('supplierPanel-v2.companyWorkingTimes', {
                parent: 'supplierPanel-v2',
                url: '/companyWorkingTimes',

                views: {
                    'content@': {
                        templateUrl: 'app/entities/schedule-info/scheduling/company-scheduling-v2.html',
                        controller: 'CompanySchedulingV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('serviceCapacityInfo');
                        $translatePartialLoader.addPart('messages');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItemStatus');
                        $translatePartialLoader.addPart('servant');
                        $translatePartialLoader.addPart('scheduleInfo');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.companyLocationInfo', {
                parent: 'supplierPanel-v2',
                url: '/companyLocationInfo',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/location-info/company-location-info-v2.html',
                        controller: 'CompanyLocationInfoController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('locationInfo');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'CompanyInfoQuery', function ($stateParams, CompanyInfoQuery) {

                        return CompanyInfoQuery.getCurrentCompanyInfo().query().$promise;
                    }]

                }
            })
            .state('supplierPanel-v2.companySocialNetworkInfo', {
                parent: 'supplierPanel-v2',
                url: '/companySocialNetworkInfo?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.companySocialNetworkInfo.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/company-social-network-info/custom-company-social-network-infos-v2.html',
                        controller: 'CompanySocialNetworkInfoControllerCustom',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('companySocialNetworkInfo');
                        $translatePartialLoader.addPart('socialNetworkType');
                        $translatePartialLoader.addPart('socialNetworkInfo');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }]
                }
            })
            .state('supplierPanel-v2.companySettingInfo', {
                parent: 'supplierPanel-v2',
                url: '/companySettingInfo/:settingFormSection',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/setting-info/company-setting-info-v2.html',
                        controller: 'CompanySettingInfoController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('settingInfo');
                        $translatePartialLoader.addPart('notificationSetting');
                        $translatePartialLoader.addPart('financialSetting');
                        $translatePartialLoader.addPart('themeSettingInfo');
                        $translatePartialLoader.addPart('notificationType');
                        $translatePartialLoader.addPart('currency');
                        return $translate.refresh();
                    }]
                }
            })
             .state('supplierPanel-v2.companyBankAccountInfo', {
                parent: 'supplierPanel-v2',
                url: '/companyBankAccountInfo',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/bank-account-info/company-bank-account-info-v2.html',
                        controller: 'CompanyBankAccountInfoController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('bankAccountInfo');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.companyBankAccountInfoV2', {
                parent: 'supplierPanel-v2',
                url: '/companyBankAccountInfoV2',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/bank-account-info/company-bank-account-info-v3.html',
                        controller: 'CompanyBankAccountInfoControllerV3',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('bankAccountInfo');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.companyCustomSetting', {
                parent: 'supplierPanel-v2',
                url: '/companyCustomSetting',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.customSetting.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/customSetting/custom-setting-v2.html',
                        controller: 'CustomSettingController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['CompanyInfoQuery', function (CompanyInfoQuery) {

                        return CompanyInfoQuery.getCurrentCompanyInfo().query().$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('customSetting');
                        $translatePartialLoader.addPart('company');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            //coupon
            .state('supplierPanel-v2.couponList', {
                parent: 'supplierPanel-v2',
                url: '/coupon-list',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.coupon.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/coupon/coupons-list-v2.html',
                        controller: 'CouponListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('coupon');
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('couponGenerateTypes');
                        $translatePartialLoader.addPart('couponStatus');


                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.newCoupon', {
                parent: 'supplierPanel-v2',
                url: '/coupon-list/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/coupon/coupon-v2.html',
                        controller: 'CouponV2Controller',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('coupon');
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('couponGenerateTypes');
                        $translatePartialLoader.addPart('couponStatus');
                        $translatePartialLoader.addPart('amountTypes');
                        // $translatePartialLoader.addPart('serviceItem');
                        // $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            id: null
                        };
                    }
                }
            })
            .state('supplierPanel-v2.editCoupon', {
                parent: 'supplierPanel-v2',
                url: '/coupon-list/edit/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/coupon/coupon-v2.html',
                        controller: 'CouponV2Controller',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('coupon');
                        $translatePartialLoader.addPart('couponGenerateTypes');
                        $translatePartialLoader.addPart('amountTypes');
                        $translatePartialLoader.addPart('couponStatus');
                        // $translatePartialLoader.addPart('serviceItem');
                        // $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['Coupon', '$stateParams', function (Coupon, $stateParams) {

                        return Coupon.get({id: $stateParams.id}).$promise;
                    }]
                }
                // resolve: {
                //     entity: ['CompanyCustomer', function(CompanyCustomer) {
                //         return CompanyCustomer.get({id : $stateParams.id}).$promise;
                //     }]
                // }
            })
            .state('supplierPanel-v2.deleteCoupon', {
                parent: 'supplierPanel-v2.editCoupon',
                url: '/coupon-list/delete/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/coupon/coupon-delete-dialog.html',
                        controller: 'CouponDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Coupon', function (Coupon) {
                                return Coupon.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('supplierPanel-v2.couponList', null, {reload: 'coupon'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.deleteCouponFromList', {
                parent: 'supplierPanel-v2.couponList',
                url: '/coupon-list/delete/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/coupon/coupon-delete-dialog.html',
                        controller: 'CouponDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Coupon', function (Coupon) {
                                return Coupon.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('^');
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            //.............

            //reserve limit
            .state('supplierPanel-v2.reserveLimitList', {
                parent: 'supplierPanel-v2',
                url: '/reserve-limit-list',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.reserveLimit.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/reserve-limit/reserve-limits-list-v2.html',
                        controller: 'ReserveLimitsListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('reserveLimit');
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('reserveLimitTypes');
                        $translatePartialLoader.addPart('reserveLimitStatus');
                        $translatePartialLoader.addPart('reserveLimitPeriod');


                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.editReserveLimit', {
                parent: 'supplierPanel-v2',
                url: '/reserve-limit-list/edit/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/reserve-limit/reserve-limit-v2.html',
                        controller: 'ReserveLimitV2Controller',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('reserveLimit');
                        $translatePartialLoader.addPart('reserveLimitTypes');
                        $translatePartialLoader.addPart('reserveLimitStatus');
                        $translatePartialLoader.addPart('reserveLimitPeriod');
                        return $translate.refresh();
                    }],
                    entity: ['ReserveLimit', '$stateParams', function (ReserveLimit, $stateParams) {

                        return ReserveLimit.get({id: $stateParams.id}).$promise;
                    }]
                }
                // resolve: {
                //     entity: ['CompanyCustomer', function(CompanyCustomer) {
                //         return CompanyCustomer.get({id : $stateParams.id}).$promise;
                //     }]
                // }
            })
            .state('supplierPanel-v2.newReserveLimit', {
                parent: 'supplierPanel-v2',
                url: '/reserve-limit-list/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/reserve-limit/reserve-limit-v2.html',
                        controller: 'ReserveLimitV2Controller',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('reserveLimit');
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('reserveLimitTypes');
                        $translatePartialLoader.addPart('reserveLimitStatus');
                        $translatePartialLoader.addPart('reserveLimitPeriod');
                        // $translatePartialLoader.addPart('serviceItem');
                        // $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            id: null
                        };
                    }
                }
            })
            .state('supplierPanel-v2.deleteReserveLimit', {
                parent: 'supplierPanel-v2.reserveLimitList',
                url: '/reserve-limit-ist/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', function ($stateParams, $state, $uibModal, $rootScope) {
                    $uibModal.open({
                        templateUrl: 'app/entities/reserve-limit/reserve-limit-delete-dialog-v2.html',
                        controller: 'ReserveLimitDeleteV2Controller',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['ReserveLimit', function (ReserveLimit) {
                                return ReserveLimit.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        if ($rootScope.modalInstance) {
                            $rootScope.modalInstance.dismiss('cancel');
                        }
                        $state.go('supplierPanel-v2.reserveLimitList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            //...................
            // dashboard onBoarding
            .state('supplierPanel-v2.dashboard.companySettingInfo', {
                parent: 'supplierPanel-v2.dashboard',
                url: '/companySettingInfo/:settingFormSection',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/setting-info/company-setting-info-v2.html',
                        controller: 'CompanySettingInfoController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('settingInfo');
                        $translatePartialLoader.addPart('notificationSetting');
                        $translatePartialLoader.addPart('financialSetting');
                        $translatePartialLoader.addPart('themeSettingInfo');
                        $translatePartialLoader.addPart('notificationType');
                        $translatePartialLoader.addPart('currency');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.dashboard.newServiceItem', {
                parent: 'supplierPanel-v2.dashboard',
                url: '/serviceItem/{id}',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/service-item-v2/service-item-v2.html',
                        controller: 'ServiceItemV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('serviceCapacityInfo');
                        $translatePartialLoader.addPart('messages');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItemStatus');
                        $translatePartialLoader.addPart('servicePaymentType');
                        $translatePartialLoader.addPart('serviceConfirmationType');
                        $translatePartialLoader.addPart('amenitiesType');
                        $translatePartialLoader.addPart('weekDay');
                        return $translate.refresh();
                    }],
                    entity: ['$rootScope', '$stateParams', 'ServiceItem', function ($rootScope, $stateParams, ServiceItem) {
                        return {};
                    }]
                }
            })
            .state('supplierPanel-v2.dashboard.newCompanyServant', {
                parent: 'supplierPanel-v2.dashboard',
                url: '/newCompanyServant',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/company-servants/company-servants-v2-dialog.html',
                        controller: 'CompanyServantsV2DialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('servant');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            title: null,
                            level: null,
                            id: null
                        };
                    }
                }
                // });
            })
            .state('supplierPanel-v2.dashboard.companyWorkingTimes', {
                parent: 'supplierPanel-v2.dashboard',
                url: '/companyWorkingTimes',

                views: {
                    'content@': {
                        templateUrl: 'app/entities/schedule-info/scheduling/company-scheduling-v2.html',
                        controller: 'CompanySchedulingV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('supplierPanel');
                        $translatePartialLoader.addPart('home');
                        $translatePartialLoader.addPart('serviceCapacityInfo');
                        $translatePartialLoader.addPart('messages');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceItemStatus');
                        $translatePartialLoader.addPart('servant');
                        $translatePartialLoader.addPart('scheduleInfo');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.dashboard.newReserve', {
                parent: 'supplierPanel-v2.dashboard',
                url: '/reserve-modal/new/{serviceItemId}/{start_date}/{end_date}/{servantId}/{hasCustomTime}',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/reserve/new-reserve-modal-v2.html',
                        controller: 'ReserveV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('orderBag');
                        $translatePartialLoader.addPart('orderBagServiceItem');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('genderType');

                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            customer: null,
                            createDate: null,
                            status: 0,
                            id: null,
                            orderBagServiceItems: [{}]
                        };
                    }

                }
            })
            //......................

            // CustomerGroup
            .state('supplierPanel-v2.customerGroupList', {
                parent: 'supplierPanel-v2',
                url: '/customer-group-list',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.customerGroup.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/customer-group/customer-groups-list-v2.html',
                        controller: 'CustomerGroupListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('customerGroup');
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');


                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.newCustomerGroup', {
                parent: 'supplierPanel-v2',
                url: '/customer-group-list/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/customer-group/customer-group-v2.html',
                        controller: 'CustomerGroupV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {


                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('customerGroup');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            id: null
                        };
                    }
                }
            })
            .state('supplierPanel-v2.editCustomerGroup', {
                parent: 'supplierPanel-v2',
                url: '/customer-group/edit/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/customer-group/customer-group-v2.html',
                        controller: 'CustomerGroupV2Controller',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('customerGroup');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['CustomerGroup', '$stateParams', function (CustomerGroup, $stateParams) {

                        return CustomerGroup.get({id: $stateParams.id}).$promise;
                    }]
                }
                // resolve: {
                //     entity: ['CompanyCustomer', function(CompanyCustomer) {
                //         return CompanyCustomer.get({id : $stateParams.id}).$promise;
                //     }]
                // }
            })
            .state('supplierPanel-v2.newCustomerGroup_default', {
                parent: 'supplierPanel-v2',
                url: '/customer-group-list/new_default',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/customer-group/customer-group-v2.html',
                        controller: 'CustomerGroupV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {


                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('customerGroup');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            id: null,
                            groupName: "DEFAULT_GROUP",
                            "accessToAllServices": true
                        };
                    }
                }
            })

            // InvoiceInfo
            .state('supplierPanel-v2.invoiceInfoList', {
                parent: 'supplierPanel-v2',
                url: '/invoice-info-list?pageSize&sort&searchText&filterQuery',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.invoiceInfo.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/invoice-info/invoice-infos.html',
                        controller: 'InvoiceInfoController',
                        controllerAs: 'vm'
                    }
                },
                 params: {
                    pageSize: { value: '10', squash: true },
                    sort: { value: 'id,asc', squash: true },
                    searchText: { value: null },
                    filterQuery: { value: null }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('invoiceInfo');
                        $translatePartialLoader.addPart('invoiceInfoItem');
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('invoiceStatus');
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');


                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.newInvoiceInfo', {
                parent: 'supplierPanel-v2',
                url: '/invoice-info-list/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/invoice-info/invoice-info-dialog-v2.html',
                        controller: 'InvoiceInfoDialogV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {


                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('invoiceInfo');
                        $translatePartialLoader.addPart('invoiceInfoItem');
                        $translatePartialLoader.addPart('invoiceStatus');
                        $translatePartialLoader.addPart('serviceItem');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('genderType');
                        $translatePartialLoader.addPart('serviceAddOn');

                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            id: null
                        };
                    }
                }
            })
            .state('supplierPanel-v2.editInvoiceInfo', {
                parent: 'supplierPanel-v2',
                url: '/invoice-info-list/edit/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/invoice-info/invoice-info-dialog-v2.html',
                        controller: 'InvoiceInfoDialogV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('invoiceInfo');
                        $translatePartialLoader.addPart('invoiceStatus');
                        $translatePartialLoader.addPart('invoiceInfoItem');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('serviceAddOn');
                        return $translate.refresh();
                    }],
                    entity: ['InvoiceInfoCustom', '$stateParams', function (InvoiceInfoCustom, $stateParams) {

                        return InvoiceInfoCustom.getInvoiceWithItemsById($stateParams.id).query().$promise;
                    }]
                }
                // resolve: {
                //     entity: ['CompanyCustomer', function(CompanyCustomer) {
                //         return CompanyCustomer.get({id : $stateParams.id}).$promise;
                //     }]
                // }
            })
            .state('supplierPanel-v2.invoiceInfoDetail', {
                parent: 'supplierPanel-v2',
                url: '/invoice-info-list/detail/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/invoice-info/invoice-info-actions-v2.html',
                        controller: 'InvoiceInfoActionsV2Controller',
                        controllerAs: 'vm'
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('invoiceInfo');
                        $translatePartialLoader.addPart('invoiceInfoItem');
                        $translatePartialLoader.addPart('invoiceStatus');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('paymentType');
                        $translatePartialLoader.addPart('serviceAddOn');
                        return $translate.refresh();
                    }],
                    entity: ['InvoiceInfoCustom', '$stateParams', function (InvoiceInfoCustom, $stateParams) {

                        return InvoiceInfoCustom.getInvoiceWithItemsById($stateParams.id).query().$promise;
                    }]
                }
                // resolve: {
                //     entity: ['CompanyCustomer', function(CompanyCustomer) {
                //         return CompanyCustomer.get({id : $stateParams.id}).$promise;
                //     }]
                // }
            })
            .state('supplierPanel-v2.deleteInvoiceInfo', {
                parent: 'supplierPanel-v2.invoiceInfoList',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', function ($stateParams, $state, $uibModal, $rootScope) {
                    $uibModal.open({
                        templateUrl: 'app/entities/invoice-info/invoice-info-delete-dialog.html',
                        controller: 'InvoiceInfoDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['InvoiceInfo', function (InvoiceInfo) {
                                return InvoiceInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        if ($rootScope.modalInstance) {
                            $rootScope.modalInstance.dismiss('cancel');
                        }
                        $state.go('supplierPanel-v2.invoiceInfoList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.editInvoiceInfo.delete', {
                parent: 'supplierPanel-v2.editInvoiceInfo',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', function ($stateParams, $state, $uibModal, $rootScope) {
                    $uibModal.open({
                        templateUrl: 'app/entities/invoice-info/invoice-info-delete-dialog.html',
                        controller: 'InvoiceInfoDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['InvoiceInfo', function (InvoiceInfo) {
                                return InvoiceInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        if ($rootScope.modalInstance) {
                            $rootScope.modalInstance.dismiss('cancel');
                        }
                        $state.go('supplierPanel-v2.invoiceInfoList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.invoiceInfoDetail.delete', {
                parent: 'supplierPanel-v2.invoiceInfoDetail',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', function ($stateParams, $state, $uibModal, $rootScope) {
                    $uibModal.open({
                        templateUrl: 'app/entities/invoice-info/invoice-info-delete-dialog.html',
                        controller: 'InvoiceInfoDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['InvoiceInfo', function (InvoiceInfo) {
                                return InvoiceInfo.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        if ($rootScope.modalInstance) {
                            $rootScope.modalInstance.dismiss('cancel');
                        }
                        $state.go('supplierPanel-v2.invoiceInfoList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.printInvoiceInfo', {
                parent: 'supplierPanel-v2',
                url: '/invoice-info-list/print/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/invoice-info/print-invoice-info.html',
                        controller: 'PrintInvoiceInfoController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('invoiceInfo');
                        $translatePartialLoader.addPart('invoiceInfoItem');
                        $translatePartialLoader.addPart('invoiceStatus');
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('paymentType');
                        $translatePartialLoader.addPart('serviceAddOn');
                        return $translate.refresh();
                    }],
                    entity: ['InvoiceInfoCustom', '$stateParams', function (InvoiceInfoCustom, $stateParams) {

                        return InvoiceInfoCustom.getInvoiceWithItemsById($stateParams.id).query().$promise;
                    }]
                }
                // resolve: {
                //     entity: ['CompanyCustomer', function(CompanyCustomer) {
                //         return CompanyCustomer.get({id : $stateParams.id}).$promise;
                //     }]
                // }
            })
            .state('supplierPanel-v2.invoiceInfoDetail.editCompanyCustomer', {
                parent: 'supplierPanel-v2.invoiceInfoDetail',
                url: '/editCompanyCustomer/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/company-customer/company-customer-modal.html',
                        controller: 'CompanyCustomerModalController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('personInfo');
                        return $translate.refresh();
                    }],
                    entity: ['CompanyCustomer', '$stateParams', function (CompanyCustomer, $stateParams) {
                        return CompanyCustomer.get({id: $stateParams.id}).$promise;
                    }]
                }
                // });
            })
            //ServiceAddOn
            .state('supplierPanel-v2.serviceAddOnList', {
                parent: 'supplierPanel-v2',
                url: '/service-add-on-list',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.service-add-on.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/service-add-on/service-add-on-list.html',
                        controller: 'ServiceAddOnListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('serviceAddOn');
                        $translatePartialLoader.addPart('serviceAddOnStatus');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');


                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.newServiceAddOn', {
                parent: 'supplierPanel-v2',
                url: '/service-add-on/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/service-add-on/service-add-on.html',
                        controller: 'ServiceAddOnController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceAddOn');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('serviceAddOnStatus');
                        // $translatePartialLoader.addPart('serviceItem');
                        // $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            id: null
                        };
                    }
                }
            })
            .state('supplierPanel-v2.editServiceAddOn', {
                parent: 'supplierPanel-v2',
                url: '/service-add-on-list/edit/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/service-add-on/service-add-on.html',
                        controller: 'ServiceAddOnController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('serviceAddOn');
                        $translatePartialLoader.addPart('serviceAddOnStatus');
                        // $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['ServiceAddOn', '$stateParams', function (ServiceAddOn, $stateParams) {

                        return ServiceAddOn.get({id: $stateParams.id}).$promise;
                    }]
                }
                // resolve: {
                //     entity: ['CompanyCustomer', function(CompanyCustomer) {
                //         return CompanyCustomer.get({id : $stateParams.id}).$promise;
                //     }]
                // }
            })
            //.............

            //Marketing Campaign
            .state('supplierPanel-v2.marketingCampaignList', {
                parent: 'supplierPanel-v2',
                url: '/marketing-campaign-list',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.marketingCampaign.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/marketing-campaign/marketing-campaign-list.html',
                        controller: 'MarketingCampaignsListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null,
                    smsPanel: {
                        value: 'false',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('marketingCampaign');
                        $translatePartialLoader.addPart('marketingCampaignStatus');
                        $translatePartialLoader.addPart('marketingCampaignType');
                        $translatePartialLoader.addPart('marketingCampaignActionType');
                        $translatePartialLoader.addPart('marketingCampaignApproveStatus');
                        $translatePartialLoader.addPart('marketingCampaignNotificationType');
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');


                        return $translate.refresh();
                    }],
                    smsPanel: ['$stateParams', function ($stateParams) {
                        return false;
                    }]
                }
            })

            .state('supplierPanel-v2.smsPanelMarketingCampaignList', {
                parent: 'supplierPanel-v2',
                url: '/sms-panel-marketing-campaign-list',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.marketingCampaign.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/marketing-campaign/marketing-campaign-list.html',
                        controller: 'MarketingCampaignsListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null,
                    smsPanel: {
                        value: 'false',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('marketingCampaign');
                        $translatePartialLoader.addPart('marketingCampaignStatus');
                        $translatePartialLoader.addPart('marketingCampaignType');
                        $translatePartialLoader.addPart('marketingCampaignActionType');
                        $translatePartialLoader.addPart('marketingCampaignApproveStatus');
                        $translatePartialLoader.addPart('marketingCampaignNotificationType');
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('customer');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');


                        return $translate.refresh();
                    }],
                    smsPanel: ['$stateParams', function ($stateParams) {
                        return true;
                    }]
                }
            })

            .state('supplierPanel-v2.editMarketingCampaign', {
                parent: 'supplierPanel-v2',
                url: '/marketing-campaign-list/edit/{id}?smsPanel',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/marketing-campaign/marketing-campaign.html',
                        controller: 'MarketingCampaignController',
                        controllerAs: 'vm',
                    }
                },
                params: {
                    smsPanel: {
                        value: 'false',
                        squash: true
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('marketingCampaign');
                        $translatePartialLoader.addPart('marketingCampaignStatus');
                        $translatePartialLoader.addPart('marketingCampaignType');
                        $translatePartialLoader.addPart('marketingCampaignActionType');
                        $translatePartialLoader.addPart('marketingCampaignApproveStatus');
                        $translatePartialLoader.addPart('marketingCampaignNotificationType');
                        $translatePartialLoader.addPart('customerSegment');
                        return $translate.refresh();
                    }],
                    entity: ['MarketingCampaign', '$stateParams', function (MarketingCampaign, $stateParams) {
                        return MarketingCampaign.get({id: $stateParams.id}).$promise;
                    }],
                     smsPanel: ['$stateParams', function ($stateParams) {
                        return $stateParams.smsPanel === true || $stateParams.smsPanel === 'true';
                    }]
                }
                // resolve: {
                //     entity: ['CompanyCustomer', function(CompanyCustomer) {
                //         return CompanyCustomer.get({id : $stateParams.id}).$promise;
                //     }]
                // }
            })
            .state('supplierPanel-v2.newMarketingCampaign', {
                parent: 'supplierPanel-v2',
                url: '/marketing-campaign-list/new?smsPanel',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/marketing-campaign/marketing-campaign.html',
                        controller: 'MarketingCampaignController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    smsPanel: {
                        value: 'false',
                        squash: true
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('marketingCampaign');
                        $translatePartialLoader.addPart('companyCustomer');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('marketingCampaignStatus');
                        $translatePartialLoader.addPart('marketingCampaignType');
                        $translatePartialLoader.addPart('marketingCampaignActionType');
                        $translatePartialLoader.addPart('marketingCampaignApproveStatus');
                        $translatePartialLoader.addPart('marketingCampaignNotificationType');
                        $translatePartialLoader.addPart('customerSegment');
                        // $translatePartialLoader.addPart('serviceItem');
                        // $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            id: null
                        };
                    },
                    smsPanel: ['$stateParams', function ($stateParams) {
                        return $stateParams.smsPanel === true || $stateParams.smsPanel === 'true';
                    }]
                }
            })
            .state('supplierPanel-v2.deleteMarketingCampaign', {
                parent: 'supplierPanel-v2.marketingCampaignList',
                url: '/marketing-campaign-list/{id}/delete?smsPanel',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', function ($stateParams, $state, $uibModal, $rootScope) {
                    $uibModal.open({
                        templateUrl: 'app/entities/marketing-campaign/marketing-campaign-delete-dialog.html',
                        controller: 'MarketingCampaignDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['MarketingCampaign', function (MarketingCampaign) {
                                return MarketingCampaign.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        if ($rootScope.modalInstance) {
                            $rootScope.modalInstance.dismiss('cancel');
                        }
                        if($stateParams.smsPanel === true || $stateParams.smsPanel === 'true')
                            $state.go('supplierPanel-v2.smsPanelMarketingCampaignList', null, {reload: true});
                        else
                            $state.go('supplierPanel-v2.marketingCampaignList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })

            .state('supplierPanel-v2.deleteSmsPanelMarketingCampaign', {
                parent: 'supplierPanel-v2.smsPanelMarketingCampaignList',
                url: '/sms-panel-marketing-campaign-list/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', function ($stateParams, $state, $uibModal, $rootScope) {
                    $uibModal.open({
                        templateUrl: 'app/entities/marketing-campaign/marketing-campaign-delete-dialog.html',
                        controller: 'MarketingCampaignDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['MarketingCampaign', function (MarketingCampaign) {
                                return MarketingCampaign.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        if ($rootScope.modalInstance) {
                            $rootScope.modalInstance.dismiss('cancel');
                        }
                        $state.go('supplierPanel-v2.smsPanelMarketingCampaignList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })

            .state('supplierPanel-v2.deleteMarketingCampaignFromModal', {
                parent: 'supplierPanel-v2.editMarketingCampaign',
                url: '/deleteMarketingCampaign/{id}/delete?smsPanel',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', function ($stateParams, $state, $uibModal, $rootScope) {
                    $uibModal.open({
                        templateUrl: 'app/entities/marketing-campaign/marketing-campaign-delete-dialog.html',
                        controller: 'MarketingCampaignDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['MarketingCampaign', function (MarketingCampaign) {
                            debugger;
                                return MarketingCampaign.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        if ($rootScope.modalInstance) {
                            $rootScope.modalInstance.dismiss('cancel');
                        }
                        if($stateParams.smsPanel === true || $stateParams.smsPanel === 'true')
                            $state.go('supplierPanel-v2.smsPanelMarketingCampaignList', null, {reload: true});
                        else
                            $state.go('supplierPanel-v2.marketingCampaignList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.deleteSmsPanelMarketingCampaignFromModal', {
                parent: 'supplierPanel-v2.editMarketingCampaign',
                url: '/deleteSmsPanelMarketingCampaign/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', function ($stateParams, $state, $uibModal, $rootScope) {
                    $uibModal.open({
                        templateUrl: 'app/entities/marketing-campaign/marketing-campaign-delete-dialog.html',
                        controller: 'MarketingCampaignDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['MarketingCampaign', function (MarketingCampaign) {
                            debugger;
                                return MarketingCampaign.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        if ($rootScope.modalInstance) {
                            $rootScope.modalInstance.dismiss('cancel');
                        }
                        $state.go('supplierPanel-v2.smsPanelMarketingCampaignList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            //..........................

            //Commission
            .state('supplierPanel-v2.commissionList', {
                parent: 'supplierPanel-v2',
                url: '/commission-list',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.commission.home.title'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/commission/commission-list.html',
                        controller: 'CommissionListController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {

                        $translatePartialLoader.addPart('commission');
                        $translatePartialLoader.addPart('commissionStatus');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('global');


                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.editCommission', {
                parent: 'supplierPanel-v2',
                url: '/commission-list/edit/{id}',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/commission/commission.html',
                        controller: 'CommissionController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('commission');
                        $translatePartialLoader.addPart('commissionStatus');
                        $translatePartialLoader.addPart('commissionType');
                        $translatePartialLoader.addPart('commissionItemType');
                        return $translate.refresh();
                    }],
                    entity: ['Commission', '$stateParams', function (Commission, $stateParams) {
                        return Commission.get({id: $stateParams.id}).$promise;
                    }]
                }

            })
            .state('supplierPanel-v2.newCommission', {
                parent: 'supplierPanel-v2',
                url: '/commission-list/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/commission/commission.html',
                        controller: 'CommissionController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('commission');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('commissionStatus');
                        $translatePartialLoader.addPart('commissionType');
                        $translatePartialLoader.addPart('commissionItemType');
                        return $translate.refresh();
                    }],
                    entity: function () {

                        return {
                            id: null
                        };
                    }
                }
            })
            .state('supplierPanel-v2.deleteCommission', {
                parent: 'supplierPanel-v2.commissionList',
                url: '/commission-list/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', function ($stateParams, $state, $uibModal, $rootScope) {
                    $uibModal.open({
                        templateUrl: 'app/entities/commission/commission-delete-dialog.html',
                        controller: 'CommissionDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Commission', function (Commission) {
                                return Commission.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        if ($rootScope.modalInstance) {
                            $rootScope.modalInstance.dismiss('cancel');
                        }
                        $state.go('supplierPanel-v2.commissionList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('supplierPanel-v2.calculateCommission', {
                parent: 'supplierPanel-v2',
                url: '/commission-list/calculate-commission',
                data: {
                    authorities: ['ROLE_USER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/commission/calculate-commission.html',
                        controller: 'CalculateCommissionController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('commission');
                        $translatePartialLoader.addPart('personInfo');
                        $translatePartialLoader.addPart('commissionStatus');
                        $translatePartialLoader.addPart('commissionType');
                        $translatePartialLoader.addPart('commissionItemType');
                        $translatePartialLoader.addPart('invoiceInfo');
                        $translatePartialLoader.addPart('invoiceInfoItem');
                        $translatePartialLoader.addPart('invoiceStatus');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.editCommission.delete', {
                parent: 'supplierPanel-v2.editCommission',
                url: '/commission-list/edit/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', function ($stateParams, $state, $uibModal, $rootScope) {
                    $uibModal.open({
                        templateUrl: 'app/entities/commission/commission-delete-dialog.html',
                        controller: 'CommissionDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Commission', function (Commission) {
                                return Commission.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        if ($rootScope.modalInstance) {
                            $rootScope.modalInstance.dismiss('cancel');
                        }
                        $state.go('supplierPanel-v2.commissionList', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            //..........................
            .state('supplierPanel-v2.confirmSubscription', {
                parent: 'supplierPanel-v2',
                url: '/confirmSubscription?Authority&Status',
                data: {
                    authorities: ['ROLE_USER'],
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-subscription-status/confirm-subscription.html',
                        controller: 'ConfirmSubscriptionController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('companySubscriptionStatus');
                        $translatePartialLoader.addPart('subscriptionType');
                        $translatePartialLoader.addPart('subscriptionPackage');
                        return $translate.refresh();
                    }]
                    ,
                    entity: ['$stateParams', 'CompanySubscriptionStatusCustom', 'Auth', '$state', 'CompanySession', function ($stateParams, CompanySubscriptionStatusCustom, Auth, $state, CompanySession) {

                        CompanySession.resetCompanySession();

                        var refid = getParameterByName('refid');
                        var clientrefid = getParameterByName('clientrefid');

                        //jibimo
                        var trx = getParameterByName('trx');
                        var status = getParameterByName('status');
                        var state_code = getParameterByName('state_code');


                        if ($stateParams.Authority != '' && $stateParams.Status == 'OK') {


                            return CompanySubscriptionStatusCustom.confirmSubscription($stateParams.Authority).query(function () {
                                //CompanySubscriptionStatusCustom.findActiveCompanySubscription().query(function (active) {
                                //
                                //
                                //
                                //});
                            });

                        } else if (refid && clientrefid && refid > 1) {
                            return CompanySubscriptionStatusCustom.confirmSubscription(clientrefid, refid).query(function () {
                                //CompanySubscriptionStatusCustom.findActiveCompanySubscription().query(function (active) {
                                //
                                //
                                //
                                //});
                            });
                        } else if (trx && status && state_code && status == 1 && state_code == 99) {
                            return CompanySubscriptionStatusCustom.confirmSubscription(trx).query(function () {
                            });
                        }
                        //zify
                        else if (clientrefid) {
                            return CompanySubscriptionStatusCustom.confirmSubscription(clientrefid).query(function () {

                            });

                        } else {
                            return null;
                        }


                    }]
                }
            })

            .state('supplierPanel-v2.testServices', {
                parent: 'supplierPanel-v2',
                url: '/testServices',
                data: {
                    authorities: []
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/services/testServices/test-services.html',
                        controller: 'TestServiceController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    //translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    //    return $translate.refresh();
                    //}]
                }
            })
             .state('supplierPanel-v2.legal_actualInformation', {
                            parent: 'supplierPanel-v2',
                            url: '/legal_actual-information',
                            data: {
                                 authorities: ['ROLE_USER'],
                                 pageTitle: 'global.menu.account.legal_actual'
                            },
                          onEnter: ['$stateParams', '$state', '$uibModal', '$rootScope', 'Principal', function ($stateParams, $state, $uibModal, $rootScope, Principal) {
                               $rootScope.modalInstance = $uibModal.open({
                                    templateUrl: 'app/legal-actual-info/legal-actual-info.html',
                                    controller: 'LegalActualInfoController',
                                    controllerAs: 'vm',
                                    backdrop: 'static',
                                    size: 'lg',
                                    windowClass: 'pl-modal',
                                    resolve: {
                                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                                            $translatePartialLoader.addPart('legal_actualInformation');
                                            return $translate.refresh();
                                        }]
//                                         ,
//                                         entity: ['UserProfileQuery', function (UserProfileQuery) {
//                                             return UserProfileQuery.getCurrentPersonInfo().query();
//                                         }]
                                    }
                            })
                            $rootScope.modalInstance.result.then(function () {
                                 if ($rootScope.fromState.name)
                                    $state.go($rootScope.fromState.name, $rootScope.fromStateParams);
                                else
                                    $state.go('supplierPanel-v2.dashboard');

                            }, function () {
                                 if ($rootScope.fromState.name)
                                    $state.go($rootScope.fromState.name, $rootScope.fromStateParams);
                                else
                                    $state.go('supplierPanel-v2.dashboard');
                            });
                          }]

                        })
            .state('supplierPanel-v2.companyBlogs', {
                parent: 'supplierPanel-v2',
                url: '/companyBlogs?size&filterQuery&query',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'بلاگ ها'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-blogs/company-blogs.html',
                        controller: 'CompanyBlogs'
                    }
                },
                params: {
                    size: { value: '10', squash: true },
                    sort: { value: 'id,asc', squash: true },
                    query: { value: null },
                    filterQuery: { value: null }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyPaymentLog');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('bankAccountInfo');
                        $translatePartialLoader.addPart('paymentType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })


             .state('supplierPanel-v2.baseComponentsShowCase', {
                parent: 'supplierPanel-v2',
                url: '/base-components-showcase',
                data: {
                    pageTitle: 'base components showcase'
                },
               views: {
                    'subcontent': {
                        templateUrl: 'app/entities/base-components-showcase/base-components-showcase.html',
                        controller: 'BaseComponentsShowCase',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', function ($translate) {
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.reserveServices', {
                parent: 'supplierPanel-v2',
                url: '/reserve-services',
                data: {
                    authorities: ['ROLE_FINANCIAL_MANAGER'],
                    pageTitle: 'خدمات'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/reserve-services/reserve-services.html',
                        controller: 'ReserveServicesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    size: { value: '10', squash: true },
                    sort: { value: 'id,asc', squash: true },
                    query: { value: null },
                    filterQuery: { value: null }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyPaymentLog');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('bankAccountInfo');
                        $translatePartialLoader.addPart('paymentType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.eventServices', {
                parent: 'supplierPanel-v2',
                url: '/event-services',
                data: {
                    authorities: ['ROLE_FINANCIAL_MANAGER'],
                    pageTitle: 'خدمات'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/event-services/event-services.html',
                        controller: 'EventServicesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    size: { value: '10', squash: true },
                    sort: { value: 'id,asc', squash: true },
                    query: { value: null },
                    filterQuery: { value: null }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyPaymentLog');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('bankAccountInfo');
                        $translatePartialLoader.addPart('paymentType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.serviceCategories', {
                parent: 'supplierPanel-v2',
                url: '/service-categories',
                data: {
                    authorities: ['ROLE_FINANCIAL_MANAGER'],
                    pageTitle: 'خدمات'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/service-categories/service-categories.html',
                        controller: 'ServiceCategoriesController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    size: { value: '10', squash: true },
                    sort: { value: 'id,asc', squash: true },
                    query: { value: null },
                    filterQuery: { value: null }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('companyPaymentLog');
                        $translatePartialLoader.addPart('paymentLog');
                        $translatePartialLoader.addPart('bankAccountInfo');
                        $translatePartialLoader.addPart('paymentType');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supplierPanel-v2.metaTags', {
                parent: 'supplierPanel-v2',
                url: '/meta-tags?size&filterQuery&query',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'متاتگ ها'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/meta-tag/meta-tags-v2.html',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    size: { value: '10', squash: true },
                    sort: { value: 'id,asc', squash: true },
                    query: { value: null },
                    filterQuery: { value: null }
                },
            })
            .state('supplierPanel-v2.formBuilder', {
                parent: 'supplierPanel-v2',
                url: '/form-builder?size&filterQuery&query',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'فرم بیلدر'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/form-builder/form-builder.html',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    size: { value: '10', squash: true },
                    sort: { value: 'id,asc', squash: true },
                    query: { value: null },
                    filterQuery: { value: null }
                },
            })
            .state('supplierPanel-v2.companyBlogCategories', {
                parent: 'supplierPanel-v2',
                url: '/blog-categories?size&filterQuery&query',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'دسته بندی بلاگ'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/company-blogs/company-blog-categories.html',
                        controller: 'BlogsCategories'
                    }
                },
                params: {
                    size: { value: '10', squash: true },
                    sort: { value: 'id,asc', squash: true },
                    query: { value: null },
                    filterQuery: { value: null }
                },
            })
            .state('supplierPanel-v2.coupons', {
                parent: 'supplierPanel-v2',
                url: '/coupons?size&filterQuery&query',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'کوپن ها'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/coupon/coupons-list-v3.html',
                        controller: 'CouponsList',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    size: { value: '10', squash: true },
                    sort: { value: 'id,asc', squash: true },
                    query: { value: null },
                    filterQuery: { value: null }
                },
            })
             .state('supplierPanel-v2.reports', {
                parent: 'supplierPanel-v2',
                url: '/reports?size&filterQuery&query',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'گزارشات'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/reports/reports.html',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    size: { value: '10', squash: true },
                    sort: { value: 'id,asc', squash: true },
                    query: { value: null },
                    filterQuery: { value: null }
                },
            })
            .state('supplierPanel-v2.reserveLimits', {
                parent: 'supplierPanel-v2',
                url: '/reserve-limits?size&filterQuery&query',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'محدودیت های رزرو'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/reserve-limit/reserve-limits.html',
                        controller: 'ReserveLimitsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    size: { value: '10', squash: true },
                    sort: { value: 'id,asc', squash: true },
                    query: { value: null },
                    filterQuery: { value: null }
                },
            })
            .state('supplierPanel-v2.dynamicRules', {
                parent: 'supplierPanel-v2',
                url: '/dynamic-rules?size&filterQuery&query',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'لیست قوانین'
                },
                views: {
                    'subcontent': {
                        templateUrl: 'app/entities/dynamic-rules/dynamic-rules.html',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    size: { value: '10', squash: true },
                    sort: { value: 'id,asc', squash: true },
                    query: { value: null },
                    filterQuery: { value: null }
                },
            })
            .state('supplierPanel-v2.invoicePrint', {
                parent: 'supplierPanel-v2',
                url: '/invoice-print',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'پرینت فاکتور'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/invoice-info/print-invoice.html',
                        controllerAs: 'vm'
                    }
                }
            })
    }
})();
